/**
 * UUID v4.
 *
 * crypto.randomUUID는 보안 컨텍스트에서만 제공된다. Electron이 file://로
 * 로드될 때 없을 수 있어 대체 경로를 둔다. 메시지 id는 서버가 중복을
 * 걸러내는 열쇠라 충돌하면 남의 메시지를 덮어쓸 수 있다 —
 * Math.random()으로는 만들지 않는다.
 */
export function uuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // 버전 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // variant 10

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
